const baseURL = 'https://corporaciontechminigone.com';

export default baseURL;
